<div class="stripe-result success">
  <div class="stripe-card">
    <div class="stripe-header">
      <div class="status-icon success">
        <svg viewBox="0 0 24 24">
          <path d="M20 6L9 17l-5-5" />
        </svg>
      </div>
      <h1>Payment Successful</h1>
      <p class="subtitle">Your subscription is now active. You can start using all features immediately.</p>
    </div>

    <div class="stripe-details">
      <div class="detail-row">
        <span class="detail-label">Status</span>
        <span class="detail-value success-badge">Active</span>
      </div>
    </div>

    <div class="stripe-actions">
      <button class="stripe-btn primary" (click)="goBackToApp()">
        <svg class="btn-icon" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
        Go to App
      </button>
    </div>

    <div class="stripe-footer">
      <p class="help-text">
        Need help? <a href="mailto:support@example.com">Contact support</a> or visit our <a href="#">help center</a>
      </p>
    </div>
  </div>
</div>
